// all shared query across app

import { gql } from '@/gql/gql';

export const INTEGRATIONS_QUERY = gql(/* GraphQL */ `
  query Integrations {
    integrations {
      id
      name
      type
      status
      smartQualify
      metadata {
        contentType
        productIdentifier
        googleAdsCtids {
          ctids {
            event
            ctid {
              id
              userCreated
              selected
            }
          }
        }
      }
      filters {
        id
        eventName
        isEnabled
        propertyFilters {
          prop
          operator
          value
        }
      }
      credentials {
        ... on MetaCredentials {
          accessToken
          id
        }
        ... on GA4Credentials {
          measurementId
        }
        ... on KlaviyoCredentials {
          apiKey
        }
        ... on PostscriptCredentials {
          shopToken
        }
        ... on SnapchatCredentials {
          accessToken
          snapchatId
        }
        ... on TiktokCredentials {
          accessToken
          tiktokId
        }
        ... on GoogleAdsCredentials {
          customerId
          merchantId
        }
      }
      consentMode
    }
  }
`);

export const INTEGRATION_QUERY = gql(/* GraphQL */ `
  query Integration($id: ID!) {
    integration(id: $id) {
      id
      name
      type
      status
      consentMode
      smartQualify
      metadata {
        contentType
        productIdentifier
        googleAdsCtids {
          ctids {
            event
            ctid {
              id
              userCreated
              selected
            }
          }
        }
      }
      filters {
        id
        eventName
        isEnabled
        propertyFilters {
          prop
          operator
          value
        }
      }
      credentials {
        ... on MetaCredentials {
          accessToken
          id
        }
        ... on GA4Credentials {
          measurementId
        }
        ... on KlaviyoCredentials {
          apiKey
        }
        ... on PostscriptCredentials {
          shopToken
        }
        ... on SnapchatCredentials {
          accessToken
          snapchatId
        }
        ... on TiktokCredentials {
          accessToken
          tiktokId
        }
        ... on GoogleAdsCredentials {
          customerId
          merchantId
        }
      }
    }
  }
`);

export const GOOGLE_ADS_CONVERSION_ACTION_QUERY = gql(/* GraphQL */ `
  query GoogleAdsConversion($id: ID!, $customerId: String!) {
    googleAdsGetConversionActions(id: $id, customerId: $customerId) {
      id
      name
      status
      type
    }
  }
`);

export const INTEGRATIONS_V2_QUERY = gql(/* GraphQL */ `
  query IntegrationsV2 {
    integrationsV2 {
      id
      name
      type
      status
      metadata {
        __typename
        ... on MetaMetadataModel {
          contentType
          productIdentifier
          tagDelivery
        }
        ... on GA4MetadataModel {
          productIdentifier
        }
        ... on GoogleAdsMetadataModel {
          contentType
          productIdentifier
          googleAdsCtids {
            ctids
          }
        }
        ... on TikTokMetadataModel {
          contentType
          productIdentifier
          tagDelivery
        }
        ... on SnapchatMetadataModel {
          contentType
          productIdentifier
          tagDelivery
        }
      }
      credentials {
        __typename
        ... on MetaCredentialsModel {
          accessToken
          id
        }
        ... on GA4CredentialsModel {
          measurementId
        }
        ... on KlaviyoCredentialsModel {
          apiKey
        }
        ... on PostscriptCredentialsModel {
          shopToken
        }
        ... on SnapchatCredentialsModel {
          accessToken
          snapchatId
        }
        ... on TikTokCredentialsModel {
          accessToken
          tiktokId
        }
        ... on GoogleAdsCredentialsModel {
          customerId
          merchantId
        }
        ... on AttentiveCredentialsModel {
          attentiveApiKey
        }
        ... on RedoCredentialsModel {
          redoAccessToken
          redoStoreId
          redoWidgetId
        }
        ... on WebhookCredentialsModel {
          webhookUrl
        }
      }
      consentMode
      smartQualify
      findFiltersV2 {
        id
        eventName
        isEnabled
        propertyFilters {
          prop
          operator
          value
        }
      }
    }
  }
`);

export const INTEGRATION_V2_QUERY = gql(/* GraphQL */ `
  query IntegrationV2($id: ID!) {
    integrationV2(id: $id) {
      id
      name
      type
      status
      metadata {
        __typename
        ... on MetaMetadataModel {
          contentType
          productIdentifier
          tagDelivery
        }
        ... on GA4MetadataModel {
          productIdentifier
        }
        ... on GoogleAdsMetadataModel {
          contentType
          productIdentifier
          googleAdsCtids {
            ctids
          }
        }
        ... on TikTokMetadataModel {
          contentType
          productIdentifier
          tagDelivery
        }
        ... on SnapchatMetadataModel {
          contentType
          productIdentifier
          tagDelivery
        }
      }
      credentials {
        __typename
        ... on MetaCredentialsModel {
          accessToken
          id
        }
        ... on GA4CredentialsModel {
          measurementId
        }
        ... on KlaviyoCredentialsModel {
          apiKey
        }
        ... on PostscriptCredentialsModel {
          shopToken
        }
        ... on SnapchatCredentialsModel {
          accessToken
          snapchatId
        }
        ... on TikTokCredentialsModel {
          accessToken
          tiktokId
        }
        ... on GoogleAdsCredentialsModel {
          customerId
          merchantId
        }
        ... on SendlaneCredentialsModel {
          apiKey
          integrationToken
        }
        ... on AttentiveCredentialsModel {
          attentiveApiKey
        }
        ... on RedoCredentialsModel {
          redoAccessToken
          redoStoreId
          redoWidgetId
        }
        ... on WebhookCredentialsModel {
          webhookUrl
        }
      }
      consentMode
      smartQualify
      findFiltersV2 {
        id
        eventName
        isEnabled
        propertyFilters {
          prop
          operator
          value
        }
      }
    }
  }
`);
